// extracted by css-extract-rspack-plugin
export default {"Tooltip":"Tooltip--DTcdP","TooltipContent":"TooltipContent--hkWWu","TooltipItems":"TooltipItems--QDB__"};